import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Switching cards with unsaved changes (brief §3): "Save changes to [card]?"
 * Keep editing · Discard · Save. The theme's MUI `Dialog`, as v1's status
 * modal is; Esc and the backdrop keep editing, so nothing is lost by accident.
 */
export type UnsavedChangesDialogProps = {
  open: boolean;
  /** The card being edited, by name. */
  cardTitle: string;
  onKeepEditing: () => void;
  onDiscard: () => void;
  onSave: () => void;
};

export const UnsavedChangesDialog = ({
  open,
  cardTitle,
  onKeepEditing,
  onDiscard,
  onSave,
}: UnsavedChangesDialogProps) => {
  const { t } = useTranslation('pmDetails');
  return (
    <Dialog
      open={open}
      onClose={onKeepEditing}
      aria-labelledby="details-unsaved-title"
      data-automation-id="details-unsaved-dialog"
    >
      <DialogTitle id="details-unsaved-title">
        {t('confirm.Title', { card: cardTitle })}
      </DialogTitle>
      <DialogContent>
        <Typography variant="bodyRegular">{t('confirm.Body')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="secondary"
          onClick={onKeepEditing}
          data-automation-id="details-unsaved-keep"
        >
          {t('confirm.Keep')}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onDiscard}
          data-automation-id="details-unsaved-discard"
        >
          {t('confirm.Discard')}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onSave}
          data-automation-id="details-unsaved-save"
        >
          {t('confirm.Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
